



























































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
@Component({})

export default class ContentModal extends Vue {
  @Prop({ type: Boolean, default: false})
  public showModal!: boolean;
  @Prop({ type: String, default: '400px' })
  public modalWidth!: string;
  @Prop({ type: String, default: '400px' })
  public modalHeight!: string;
  @Prop({ type: Boolean, default: true })
  public modalCloseButton!: boolean;
  @Prop({ type: Boolean, default: false })
  public fullSize!: boolean;

  private screenSize: number = window.innerWidth;

  private data() {
    return {
      topGears: {
        gearA: {
          url: require('../../assets/modal-assets/top-gear-A_146x146.png'),
          alt: 'Top Gear A',
          highlight: require('../../assets/modal-assets/top-gear-A-high_146x146.png'),
          highAlt: 'Top Gear A Highlight',
        },
        gearB: {
          url: require('../../assets/modal-assets/top-gear-B_92x92.png'),
          alt: 'Top Gear B',
          highlight: require('../../assets/modal-assets/top-gear-B-high_92x92.png'),
          highAlt: 'Top Gear B Highlight',
        },
        gearC: {
          url: require('../../assets/modal-assets/top-gear-C_164x164.png'),
          alt: 'Top Gear C',
          highlight: require('../../assets/modal-assets/top-gear-C-high_164x164.png'),
          highAlt: 'Top Gear C Highlight',
        },
      },
      bottomGears: {
        gearA: {
          url: require('../../assets/modal-assets/bottom-gear-A_124x124.png'),
          alt: 'Bottom Gear A',
          highlight: require('../../assets/modal-assets/bottom-gear-A-high_124x124.png'),
          highAlt: 'Bottom Gear A Highlight',
        },
        gearB: {
          url: require('../../assets/modal-assets/bottom-gear-B_184x184.png'),
          alt: 'Bottom Gear B',
          highlight: require('../../assets/modal-assets/bottom-gear-B-high_184x184.png'),
          highAlt: 'Bottom Gear B Highlight',
        },
        gearC: {
          url: require('../../assets/modal-assets/bottom-gear-C_160x160.png'),
          alt: 'Bottom Gear C',
        },
      },
    };
  }



  @Watch('screenSize')
  private onchange(val: number, oldVal: number) {
    this.screenSize = val;
  }

  private mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.screenSize = window.innerWidth;
      });
    });
  }

  private closeModal() {
    this.$emit('closeModal');
  }

}
